import { render, staticRenderFns } from "./viewallNews.vue?vue&type=template&id=56ea8b5c&scoped=true"
import script from "./viewallNews.vue?vue&type=script&lang=js"
export * from "./viewallNews.vue?vue&type=script&lang=js"
import style0 from "./viewallNews.vue?vue&type=style&index=0&id=56ea8b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea8b5c",
  null
  
)

export default component.exports